<template>
  <v-container class="pt-3 pb-0">
    <h4 class="title grey--text text--darken-1 pt-0 pb-3">
      <router-link
        class="grey--text text--darken-1 no-decoration"
        :to="`${pageTopSlug}/${infoBox.slug}`"
        v-html="infoBox.title_plain" />
    </h4>
    <div v-html="infoBox.content" />
  </v-container>
</template>
<script>
  export default {
    name: 'InfoBox',
    data () {
      return {
        infoBox: this.$store.getters.getInfoBox,
        pageTopSlug: this.$store.state.pageTopSlug
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/InfoBox.vue